

function initVacancies(container) {
    const showButton = container.querySelector('.latest-vacancies__show-more')
    const ctaButton = container.querySelector('.latest-vacancies__cta')

    if (showButton) {
        showButton.addEventListener('click', showVacancies);
    }
    
    function showVacancies() {
        this.classList.remove('active')
        container.classList.add('show-more')
        ctaButton.classList.add('active')
    }
}


[...document.querySelectorAll('.latest-vacancies')].map(initVacancies)
